import Banner from '@core/models/banners/Banner';
import { BannerCategory } from '@core/models/banners/enums';
import StoreUtil from '@store/StoreUtil';
import BannersService from '@core/services/banners/BannersService';
import { Commit } from 'vuex';

const SET_QUICK_LINKS = 'SET_QUICK_LINKS';
const SET_PROMOTIONS = 'SET_PROMOTIONS';
const SET_SKYSCRAPERS = 'SET_SKYSCRAPERS';
const SET_VIRTUALS = 'SET_VIRTUALS';
const SET_GAMES = 'SET_GAMES';
const SET_PROMOTED_TOURNAMENTS = 'SET_PROMOTED_TOURNAMENTS';

export interface IBannersState {
    [BannerCategory.quickLinks]: Banner[];
    [BannerCategory.promotions]: Banner[];
    [BannerCategory.skyscrapers]: Banner[];
    [BannerCategory.virtuals]: Banner[];
    [BannerCategory.games]: Banner[];
    [BannerCategory.promotedTournaments]: Banner[];
}

function defaultState(): IBannersState {
    return {
        [BannerCategory.quickLinks]: [],
        [BannerCategory.promotions]: [],
        [BannerCategory.skyscrapers]: [],
        [BannerCategory.virtuals]: [],
        [BannerCategory.games]: [],
        [BannerCategory.promotedTournaments]: [],
    } as IBannersState;
}

export default {
    state: defaultState(),

    mutations: {
        [SET_QUICK_LINKS]: StoreUtil.createSimpleMutator(BannerCategory.quickLinks),
        [SET_PROMOTIONS]: StoreUtil.createSimpleMutator(BannerCategory.promotions),
        [SET_SKYSCRAPERS]: StoreUtil.createSimpleMutator(BannerCategory.skyscrapers),
        [SET_VIRTUALS]: StoreUtil.createSimpleMutator(BannerCategory.virtuals),
        [SET_GAMES]: StoreUtil.createSimpleMutator(BannerCategory.games),
        [SET_PROMOTED_TOURNAMENTS]: StoreUtil.createSimpleMutator(BannerCategory.promotedTournaments as any),
    },

    getters: {
        /*
         * Banners that are used as additional navbar space on landing page.
         * Examples: banner with link to news page, banner with link to help page
         */
        quickLinkBanners: StoreUtil.createSimpleGetter(BannerCategory.quickLinks),
        /*
         * Promotion pads on landing page.
         */
        promotionBanners: StoreUtil.createSimpleGetter(BannerCategory.promotions),
        /*
         * Vertical banners under the sidebar.
         */
        skyscraperBanners: StoreUtil.createSimpleGetter(BannerCategory.skyscrapers),
        /*
         * Virtual page banners.
         */
        virtualBanners: StoreUtil.createSimpleGetter(BannerCategory.virtuals),
        /*
         * Banners that are shown on Casino live and Games page.
         */
        gamesBanners: StoreUtil.createSimpleGetter(BannerCategory.games),
        /*
         * "Zvake"
         */
        promotedTournamentBanners: StoreUtil.createSimpleGetter(BannerCategory.promotedTournaments as any),
    },

    actions: {
        fetchQuickLinkBanners: fetchBannerAction(BannerCategory.quickLinks, SET_QUICK_LINKS),
        fetchPromotionBanners: fetchBannerAction(BannerCategory.promotions, SET_PROMOTIONS),
        fetchSkyscraperBanners: fetchBannerAction(BannerCategory.skyscrapers, SET_SKYSCRAPERS),
        fetchVirtualBanners: fetchBannerAction(BannerCategory.virtuals, SET_VIRTUALS),
        fetchPromotedTournamentBanners: fetchBannerAction(BannerCategory.promotedTournaments, SET_PROMOTED_TOURNAMENTS),
        fetchGameBanners: fetchBannerAction(BannerCategory.games, SET_GAMES),
    },

    namespaced: true
};

function fetchBannerAction(bannerCategory: BannerCategory, mutation: string) {
    return StoreUtil.asyncErrorGuard(async({ commit }: {commit: Commit}) => {
        const banners = await BannersService.getInstance().getBannersByCategory(bannerCategory);
        commit(mutation, banners);
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/banners/bannerIndex.ts